import { Check } from "lucide-react";
import { OUTCOMES } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

export const Outcomes = () => (
  <section
    id="czego-sie-nauczysz"
    data-testid="outcomes-section"
    className="scroll-mt-24 border-y-4 border-ink bg-cyan"
  >
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="03" label="Efekty" color="bg-white" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 max-w-3xl text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Czego nauczysz się na kursie
        </h2>
        <p className="mt-4 max-w-2xl text-base font-semibold leading-relaxed text-ink/75 sm:text-lg">
          Po ukończeniu kursu będziesz potrafić:
        </p>
      </Reveal>

      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {OUTCOMES.map((outcome, i) => (
          <Reveal key={outcome} delay={(i % 3) * 0.08} className="h-full">
            <li
              data-testid={`outcome-card-${i + 1}`}
              className="hover-lift flex h-full items-start gap-3 rounded-2xl border-2 border-ink bg-white p-5 shadow-hard-sm"
            >
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-ink bg-magenta">
                <Check className="h-4 w-4 text-white" strokeWidth={3.5} aria-hidden="true" />
              </span>
              <span className="text-sm font-semibold leading-relaxed text-ink sm:text-base">
                {outcome}
              </span>
            </li>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
